<template>
    <div class="all-places-items">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-6">
                    <div class="section_title">
                        <h1>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <g id="Group_1" data-name="Group 1" transform="translate(-820 -204)">
                                <g id="trend-up_linear" data-name="trend-up/linear" transform="translate(820 204)">
                                <g id="vuesax_linear_trend-up" data-name="vuesax/linear/trend-up">
                                    <g id="trend-up">
                                    <path id="Vector" d="M7,20h6c5,0,7-2,7-7V7c0-5-2-7-7-7H7C2,0,0,2,0,7v6C0,18,2,20,7,20Z" transform="translate(2 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                    <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                                    </g>
                                </g>
                                </g>
                                <g id="Group" transform="translate(819.723 205.349)">
                                <path id="Vector-3" data-name="Vector" d="M0,8.386,1.729,9.672a1.769,1.769,0,0,0,1.063.319H4.918A1.687,1.687,0,0,0,6.485,8.869l1.342-3.9a1.011,1.011,0,0,0-1.063-1.39H4.531a.548.548,0,0,1-.558-.638L4.252,1.23A1.048,1.048,0,0,0,3.522.057,1.123,1.123,0,0,0,2.3.427L.011,3.691" transform="translate(9.65 5.655)" fill="none" stroke="#292d32" stroke-width="1.4"/>
                                <path id="Vector-4" data-name="Vector" d="M0,6.08V.99C0,.26.31,0,1.04,0h.52C2.29,0,2.6.26,2.6.99V6.08c0,.73-.31.99-1.04.99H1.04C.31,7.07,0,6.81,0,6.08Z" transform="translate(7 8.006)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/>
                                </g>
                            </g>
                            </svg>

                            <span>مقترحة لك</span>
                        </h1>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="row places_container suggested_places_cotainer" v-if="places" id="suggested_places_index">
                    <SuggestedPlaceItem v-for="place in places" :key="place.id" :place="place" />
                </div>
                <div class="moreLoading">
                    <template v-if="nextPage">
                        <a href="javascript:;" :class="{ 'loading': loading }" @click="loadMore"
                            class="section_subtitle load-more has-spinner-link">
                            <div class="button_text">عرض المزيد</div>
                        </a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    defineProps({
        places: Array,
        nextPage: Number | null,
        loading: Boolean | false,
        loadMore: Function // Accept the function from the parent
    });
</script>
